// SVG Import
import CommerceIcon from "@components/SVGs/commerce"
import HospitalIcon from "@components/SVGs/hospital"
import MutipleHouseIcon from "@components/SVGs/multiple_house"
import OfficeIcon from "@components/SVGs/office"
import RetainingWallIcon from "@components/SVGs/retaining_wall"
import SchoolIcon from "@components/SVGs/school"
import SingleHouseIcon from "@components/SVGs/single_house"
import SportBuildingIcon from "@components/SVGs/sport_building"
import WaterproofIcon from "@components/SVGs/waterproof"

export const texts = {
  fr: {
    variante: {
      title: {
        fr: "variantes",
        de: "varianten",
        en: "variants",
      },
    },
    seo_title: "Prémur isolé : mur préfabriqué béton avec isolant thermique",
    seo_description:
      "Notre prémur isolé sur mesure allie technique et esthétique, mur coupe feu 2H, performance thermique pour un bâtiment à énergie positive",
    title: "Le Précoffré® Thermique",
    subtitle: "Le mur à coffrage et isolation intégrés",
    cta: [
      {
        title: "Documentation",
        slug: "#download",
      },
      {
        title: "Nos réalisations",
        slug: "#gallery",
      },
      ,
      {
        title: "En savoir plus ↓",
        slug: "#main",
      },
    ],
    second_hero: {
      alt: "Prémur isolé pour Limonest | FEHR Group",
      title: "Combinez confort thermique, économie d’énergie et protection.",
      copy: "<p>Le Précoffré® Thermique, mur à coffrage et isolation intégrés, est constitué de deux parois minces en béton armé reliées et maintenues espacées par des organes de liaison (connecteurs composites et ancres porteuses), d’un isolant assurant l’isolation thermique par l’extérieur et d’un vide central permettant le coulage du <a href='/beton/' >béton prêt à l’emploi</a>.</p><p>Produit structurel réalisé sur mesure, il est livré en juste à temps sur vos chantiers et intègre l’ensemble des réservations.</p>",
    },
    product_table: {
      title: "Données techniques",
      subtitle: "(conforme à l’avis technique en cours)",
      asterix: "*selon site de production, nous consulter",
      table: {
        "Dimensions maximales ": "jusqu’à 12,34m x 3,80m*",
        "Épaisseur des murs": "de 28 à 70 cm*",
        "Épaisseur des parois ":
          "intérieur de 6 à 8 cm / extérieur de 6 à 9,5 cm",
        "Isolants ": "épaisseur de 6 à 35 cm",
        Umur: "de 0,471 à 0,063 W/m2.K",
        "Typologie des bétons": "niveau min. C 40/50",
        "Poids moyen": "env. 350 kg/m2",
        "Classification des béton": "XF1,XF3",
        "Coupe Feu": "Coupe Feu 2H – REI 120",
        "Zone sismique": "Oui",
      },
    },
    summary: [
      "Le Précoffré® Thermique, ou prémur thermique, permet d’assurer l’isolation thermique, avec un isolant côté extérieur, éliminant ainsi les ponts thermiques au niveau des liaisons avec les dalles.",
      "Sa performance Umur varie selon le besoin du projet jusqu’à 0,063 W/m2.K.",
      "Produit structurel réalisé sur mesure (jusqu’à 12,34m x 3,80m), il intègre l’ensemble des réservations et combine de multiples avantages : confort thermique hiver/été, confort acoustique, suppression des ponts thermiques, protection de l’isolant, étanchéité à l’air et à l’eau, mise en oeuvre en zone sismique, utilisation en infrastructure, utilisation sans restriction de hauteur de bâtiment et coupe-feu jusqu’à 2H.",
    ],
    hotspots: {
      title: "Schéma de principe",
      spots: [
        {
          id: "1",
          label: "Peau extérieure",
          position: { x: 350, y: 40 },
          description:
            "Nulla deserunt incididunt amet adipisicing tempor magna dolor deserunt aliquip consequat enim eu. Nulla deserunt incididunt amet adipisicing tempor magna dolor deserunt aliquip consequat enim eu.",
        },
        {
          id: "2",
          label: "Peau intérieure",
          position: { x: 400, y: 130 },
          description:
            "Et sit eiusmod aliquip laboris ea sint fugiat commodo adipisicing. Et sit eiusmod aliquip laboris ea sint fugiat commodo adipisicing.",
        },
        {
          id: "3",
          label: "Isolant de 6 à 20cm",
          position: { x: 364, y: 190 },
          description:
            "Nulla deserunt incididunt amet adipisicing tempor magna dolor deserunt aliquip consequat enim eu. Nulla deserunt incididunt amet adipisicing tempor magna dolor deserunt aliquip consequat enim eu.",
        },
        {
          id: "4",
          label: "Armature",
          position: { x: 377, y: 264 },
          description:
            "Nulla deserunt incididunt amet adipisicing tempor magna dolor deserunt aliquip consequat enim eu. Nulla deserunt incididunt amet adipisicing tempor magna dolor deserunt aliquip consequat enim eu.",
        },
        {
          id: "4",
          label: "Connecteur",
          position: { x: 382, y: 358 },
          description:
            "Nulla deserunt incididunt amet adipisicing tempor magna dolor deserunt aliquip consequat enim eu. Nulla deserunt incididunt amet adipisicing tempor magna dolor deserunt aliquip consequat enim eu.",
        },
      ],
    },
    applications: {
      title: "Domaines d'application",
      applications: [
        {
          name: "Logements individuels",
          icon: SingleHouseIcon,
        },
        {
          name: "Logements collectifs",
          icon: MutipleHouseIcon,
        },
        {
          name: "Bureaux",
          icon: OfficeIcon,
        },
        {
          name: "Commerces",
          icon: CommerceIcon,
        },
        {
          name: "Écoles",
          icon: SchoolIcon,
        },
        {
          name: "Hôpitaux",
          icon: HospitalIcon,
        },
        {
          name: "Complexes sportifs, aquatiques et culturels",
          icon: SportBuildingIcon,
        },
        {
          name: "Silos, murs de soutèment, poutres-voiles",
          icon: RetainingWallIcon,
        },
        {
          name: "Ouvrages étanches, ...",
          icon: WaterproofIcon,
        },
      ],
    },
    download_section: {
      title: "Téléchargement",
      sections: [
        {
          title: "Précoffré® Thermique",
          sub_section: [
            {
              link: [
                [
                  "éléments préfabriqués",
                  "documentation/premur/gamme_precoffre.pdf",
                ],
                [
                  "avis Technique",
                  "documentation/premur/thermique/avis_technique.pdf",
                ],
                [
                  "guide de pose -  Précoffré® Thermique",
                  "documentation/premur/classique/guide-pose-precoffre-et-thermique.pdf",
                ],
                [
                  "règles de levage - Précoffré® Thermique",
                  "documentation/premur/classique/regles_levage_precoffres.pdf",
                ],
                ["CCTP Type", "documentation/premur/classique/CCTP-TH-CL.docx"],
              ],
            },
          ],
        },
        {
          title: "Certificats Précoffré© Thermique",
          sub_section: [
            {
              title: "Site de Bischwiller",
              link: [
                [
                  "certificat NF Précoffré® Thermique",
                  "documentation/premur/thermique/bischwiller/certificat_cstb.pdf",
                ],
              ],
            },
            {
              title: "Site de Châteauneuf-sur-Isère",
              link: [
                [
                  "certificat NF Précoffré® Thermique",
                  "documentation/premur/thermique/chateauneuf-sur-isere/certificat_cstb.pdf",
                ],
              ],
            },
            {
              title: "Transport du Précoffré®",
              link: [
                [
                  "transport du Précoffré®",
                  "documentation/premur/classique/transport/transport-du-precoffre.pdf",
                ],
                [
                  "le conteneur 3.0",
                  "documentation/premur/classique/transport/conteneur-3.pdf",
                ],
              ],
            },
          ],
        },
      ],
    },
  },
  de: {
    variante: {
      title: {
        fr: "variantes",
        de: "varianten",
        en: "variants",
      },
    },
    seo_title: "Thermowand, die Doppelwand mit Dämmung - Thermofassade",
    seo_description:
      "Die Doppelwand aus Beton mit integrierte Dämmung: Technik, Ästhetik, Brandschutz Wand, maßgefertigt. Die optimale Isolierte Doppelwand",
    title: "Thermowand",
    subtitle: "Mit integrierter Schalung und Dämmung",
    cta: [
      {
        title: "Unsere Referenzen",
        slug: "#gallery",
      },
      ,
      {
        title: "Mehr erfahren ↓",
        slug: "#main",
      },
    ],
    second_hero: {
      alt: "Thermo doppelwand Limonest : Verbinden Sie Wärmekomfort, Energieeinsparung und Schutz.",
      title: "Verbinden Sie Wärmekomfort, Energieeinsparung und Schutz.",
      copy: "<p>Die Thermowand ist eine Doppelwand mit integrierter Schalung und Dämmung. Sie besteht aus zwei dünnen Stahlbetonschalen, die durch Verbindungselemente aus Kompositmaterial und durch Traganker stabil verbunden sind, einem Dämmstoff für die Außendämmung und einem zentralen Hohlraum, der mit Ortbeton verfüllt wird.</p><p>Dieses maßgefertigte tragende Element umfasst bereits alle notwendigen Aussparungen und wird just-in-time an Ihrer Baustelle angeliefert.</p>",
      exlusivity: "Exklusiv bei der Gruppe Fehr",
    },
    applications: {
      title: "Anwendungen",
      applications: [
        {
          name: "Geeignet für Ein",
          icon: SingleHouseIcon,
        },
        {
          name: "Mehrfamilienhäuser",
          icon: MutipleHouseIcon,
        },
        { name: "Büros", icon: OfficeIcon },
        {
          name: "Commerces, Geschäfte",
          icon: CommerceIcon,
        },
        { name: "Schulen", icon: SchoolIcon },
        {
          name: "Krankenhäuser",
          icon: HospitalIcon,
        },
        {
          name: "Sport-, Bäder- und Kulturkomplexe",
          icon: SportBuildingIcon,
        },
        {
          name: "Siloanlagen, Stützmauern, dichte Bauwerke, Tragschalen",
          icon: RetainingWallIcon,
        },
        {
          name: "Wasserdichte Konstruktionen, ...",
          icon: WaterproofIcon,
        },
      ],
    },
    product_table: {
      title: "Technische Daten",
      subtitle: "(konform mit der geltenden technischen Zulassung)",
      asterix: "* je nach Produktionsstandort, bitte bei uns erfragen",
      table: {
        "Max. Abmessungen": "bis 12,34 m x 3,80 m*",
        "Wanddicke ": "28 bis 70 cm*",
        Dämmstoff: "Dicke: 6 bis 35 cm",
        UWand: "0,471 bis 0,063 W/m2.K",
        "Beton-Festigkeitsklassen": "mind. C 40/50",
        "Durchschnittsgewicht ": "ca. 350 kg/m2",
        "Beton-Expositionsklassen": "XF1, XA3",
        Brandschutz: "2H – REI 120",
        Erdbebengebiet: "Ja",
      },
    },
    summary: [
      "Die Thermowand, ermöglicht die Wärmedämmung, mit einer Isolierung auf der Außenseite, und eliminiert so die Wärmebrücken im Bereich der Verbindungen zu den Decken",
      "Seine Umur-Leistung variiert je nach Bedarf des Projekts bis zu 0,063 W/m2.K.",
      "Als maßgefertigtes Strukturprodukt (bis zu 12,34m x 3,80m) integriert es alle Reservierungen und vereint zahlreiche Vorteile: thermischer Komfort im Winter/Sommer, akustischer Komfort, Beseitigung von Wärmebrücken, Schutz der Isolierung, Luft- und Wasserdichtigkeit, Einsatz in Erdbebengebieten, Verwendung in der Infrastruktur, Verwendung ohne Einschränkung der Gebäudehöhe und Brandschutz bis zu 2H.",
    ],
    hotspots: {
      title: "Schemazeichnung",
      spots: [
        {
          id: "1",
          label: "Äußere Haut",
          position: { x: 350, y: 40 },
          description:
            "Nulla deserunt incididunt amet adipisicing tempor magna dolor deserunt aliquip consequat enim eu. Nulla deserunt incididunt amet adipisicing tempor magna dolor deserunt aliquip consequat enim eu.",
        },
        {
          id: "2",
          label: "Innere Haut",
          position: { x: 400, y: 130 },
          description:
            "Et sit eiusmod aliquip laboris ea sint fugiat commodo adipisicing. Et sit eiusmod aliquip laboris ea sint fugiat commodo adipisicing.",
        },
        {
          id: "3",
          label: "Isolierung von 6 bis 20cm",
          position: { x: 364, y: 190 },
          description:
            "Nulla deserunt incididunt amet adipisicing tempor magna dolor deserunt aliquip consequat enim eu. Nulla deserunt incididunt amet adipisicing tempor magna dolor deserunt aliquip consequat enim eu.",
        },
        {
          id: "4",
          label: "Gerüst",
          position: { x: 377, y: 264 },
          description:
            "Nulla deserunt incididunt amet adipisicing tempor magna dolor deserunt aliquip consequat enim eu. Nulla deserunt incididunt amet adipisicing tempor magna dolor deserunt aliquip consequat enim eu.",
        },
        {
          id: "4",
          label: "Verbinder",
          position: { x: 382, y: 358 },
          description:
            "Nulla deserunt incididunt amet adipisicing tempor magna dolor deserunt aliquip consequat enim eu. Nulla deserunt incididunt amet adipisicing tempor magna dolor deserunt aliquip consequat enim eu.",
        },
      ],
    },
  },
  en: {
    variante: {
      title: {
        fr: "variantes",
        de: "varianten",
        en: "variants",
      },
    },
    seo_title: "Thermal precast wall : thermal comfort, Fire protection",
    seo_description:
      "FEHR precast thermal wall : the precast wall with insulation: comfort, technical, made to measure, Fire protection. Quick, safety and easy to install",
    title: "Precast Thermal Wall",
    subtitle: "The wall with integrated formwork and insulation",
    cta: [
      {
        title: "Our achievements",
        slug: "#gallery",
      },
      ,
      {
        title: "Read more ↓",
        slug: "#main",
      },
    ],
    second_hero: {
      alt: "combine thermal comfort, energy savings and protection.",
      title: "combine thermal comfort, energy savings and protection.",
      copy: "<p>Precast Thermal Wall is a precast wall with integrated formwork made up of two fine reinforced concrete panels that are connected to each other and held apart by a system of connectors (composite connectors and load-bearing anchors),  providing external wall insulation and a central space into which ready-mix concrete can be cast.</p><p>This made-to-order structural product is delivered just in time to your work sites, with all the reservations required.</p>",
    },
    product_table: {
      title: "Technical Characteristics",
      subtitle: "(according to current Technical Notice)",
      asterix:
        "* depending on production site; please enquire for more information",
      table: {
        "Max dimensions": "up to 12.34m x 3.80m*",
        "Wall thickness": "from 28 to 70 cm*",
        "Wall panel thickness": "6 to 8 cm interior / 6 to 9.5 cm exterior",
        Insulation: "6 to 35 cm thick",
        Uwall: "0.471 to 0,063 W/m2.K",
        "Concrete class": "min. C 40/50",
        "Average weight": "approx. 350 kg/m2",
        "Concrete exposure classes": "XF1; XA3",
        "Fire resistance": "2H – REI 120",
        "Seismic zone": "Yes",
      },
    },
    summary: [
      "Précoffré® Thermique, or thermal precast, provides thermal insulation, with insulation on the outside, thus eliminating thermal bridges at slab connections",
      "Its Umur performance varies according to project requirements, up to 0,063 W/m2.K.",
      "A structural product made to measure (up to 12.34m x 3.80m), it integrates all reservations and combines multiple advantages: winter/summer thermal comfort, acoustic comfort, elimination of thermal bridges, insulation protection, air and watertightness, implementation in seismic zones, use in infrastructure, use without building height restrictions and fireproofing up to 2H.",
      "A structural product made to measure (up to 12.34m x 3.80m), it integrates all reservations and combines multiple advantages: winter/summer thermal comfort, acoustic comfort, elimination of thermal bridges, insulation protection, air and watertightness, implementation in seismic zones, use in infrastructure, use without building height restrictions and fireproofing up to 2H.",
    ],
    hotspots: {
      title: "Schematic diagram",
      spots: [
        {
          id: "1",
          label: "External skin",
          position: { x: 350, y: 40 },
          description:
            "Nulla deserunt incididunt amet adipisicing tempor magna dolor deserunt aliquip consequat enim eu. Nulla deserunt incididunt amet adipisicing tempor magna dolor deserunt aliquip consequat enim eu.",
        },
        {
          id: "2",
          label: "Interior skin",
          position: { x: 400, y: 130 },
          description:
            "Et sit eiusmod aliquip laboris ea sint fugiat commodo adipisicing. Et sit eiusmod aliquip laboris ea sint fugiat commodo adipisicing.",
        },
        {
          id: "3",
          label: "Insulation from 6 to 20cm",
          position: { x: 364, y: 190 },
          description:
            "Nulla deserunt incididunt amet adipisicing tempor magna dolor deserunt aliquip consequat enim eu. Nulla deserunt incididunt amet adipisicing tempor magna dolor deserunt aliquip consequat enim eu.",
        },
        {
          id: "4",
          label: "Armature",
          position: { x: 377, y: 264 },
          description:
            "Nulla deserunt incididunt amet adipisicing tempor magna dolor deserunt aliquip consequat enim eu. Nulla deserunt incididunt amet adipisicing tempor magna dolor deserunt aliquip consequat enim eu.",
        },
        {
          id: "4",
          label: "Connector",
          position: { x: 382, y: 358 },
          description:
            "Nulla deserunt incididunt amet adipisicing tempor magna dolor deserunt aliquip consequat enim eu. Nulla deserunt incididunt amet adipisicing tempor magna dolor deserunt aliquip consequat enim eu.",
        },
      ],
    },

    applications: {
      title: "Areas of use",
      applications: [
        {
          name: "Houses",
          icon: SingleHouseIcon,
        },
        {
          name: "Apartment blocks",
          icon: MutipleHouseIcon,
        },
        {
          name: "Office buildings",
          icon: OfficeIcon,
        },
        {
          name: "Shops",
          icon: CommerceIcon,
        },
        { name: "Schools", icon: SchoolIcon },
        { name: "Hospitals", icon: HospitalIcon },
        {
          name: "Sports, aquatic and arts centres",
          icon: SportBuildingIcon,
        },
        {
          name: "Silos, retaining walls, sealed structures,",
          icon: RetainingWallIcon,
        },
        {
          name: "Shell beams, etc.",
          icon: WaterproofIcon,
        },
      ],
    },
  },
}
